var render = function render(){var _vm=this,_c=_vm._self._c;return _c('g',{staticClass:"chart__connection",class:{
    animated: _vm.line == 'animated',
    dashed: _vm.line == 'dashed',
    solid: _vm.line == 'solid',
  },attrs:{"id":_vm.conn.id},on:{"click":function($event){$event.stopPropagation();return _vm.$emit('click', _vm.conn)},"focus":function($event){$event.stopPropagation();return _vm.$emit('focus', _vm.conn)},"blur":function($event){$event.stopPropagation();return _vm.$emit('blur', _vm.conn)},"contextmenu":function($event){$event.preventDefault();return _vm.$emit('contextmenu', $event, _vm.conn)}}},[_c(_vm.type,_vm._b({tag:"component"},'component',{
      conn: _vm.conn,
      sourceX: _vm.sourceConnectorX,
      sourceY: _vm.sourceConnectorY,
      destX: _vm.destConnectorX,
      destY: _vm.destConnectorY,
      borderColor: _vm.borderColor,
      borderWidth: _vm.borderWidth,
    },false)),(_vm.conn.text)?_c('ConnectionText'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }